import React from 'react';
import View from './view';
import {Props} from './model';

export const Drawer: React.FC<Props> = (props) => {
  return View(props);
};
